export function clientIdentity(brand?: string | null, name = "") {
  if (brand && ["chatgpt", "claude", "gemini"].includes(brand)) return brand;
  const value = name.toLowerCase();
  if (/\bchat\s*gpt\b|\bopenai\b/.test(value)) return "chatgpt";
  if (/\bclaude\b|\banthropic\b/.test(value)) return "claude";
  if (/\bgemini\b/.test(value)) return "gemini";
  return null;
}
